SCM = SCM || {};

SCM.CollectionFacet = (function ($) {
    return {
        init: init,
        showAllItems: showAllItems,
        toggleCollectionParent: toggleCollectionParent,
        updateFacetDescendantCheckboxes: updateFacetDescendantCheckboxes,
        getUpdateQueryStringUrl: getUpdateQueryStringUrl
    };

    function init() {
        if (!myComponentIsOnPage()) {
            return;
        }
        toggleCollectionParent();
        bindEvents();
    }

    function showAllItems() {
        $('.js-collection-child-list-item').removeClass('hide');
    }

    function myComponentIsOnPage() {
        return $('.pg_SearchResults .js-collection-facet').length;
    }
    function bindEvents() {
        $(document).on('click', '.js-collection-arrow', arrowOnClick);
        $(document).on('click', '.js-collection-label:not(.js-collection-checkbox)', labelOnClick);
        $(document).on('click', '.js-collection-checkbox', checkboxOnClick);
    }

    function arrowOnClick() {
        var $icon = $(this).find('.js-collection-arrow-icon');
        if (!$icon.length) {
            $icon = $(this).parent().find('.js-collection-arrow-icon');
        }
        if (!$icon.length) {
            console.error('.js-collection-arrow-icon not found');
            return;
        }
        var siteId = $icon.data('siteid');
        if (!siteId) {
            console.error('siteid not found');
            return;
        }

        let $parentLiItem = $icon.closest('.js-collection-child-list-item');
        let $collectionUl = $parentLiItem.find('ul.collections-child-list');
        let $collectionCheckbox = $parentLiItem.find('.js-collection-checkbox');
        var $placeholder = $parentLiItem.find('.js-collection-headings-placeholder');


        if ($icon.hasClass('icon-general-arrow-filled-right')) {

            $icon.removeClass('icon-general-arrow-filled-right');
            $icon.addClass('icon-general-arrow-filled-down');

            $collectionUl.attr('aria-expanded', 'true');
            $collectionCheckbox.attr('aria-expanded', 'true');
        } else if ($icon.hasClass('icon-general-arrow-filled-down')) {

            $icon.removeClass('icon-general-arrow-filled-down');
            $icon.addClass('icon-general-arrow-filled-right');

            $collectionUl.attr('aria-expanded', 'false');
            $collectionCheckbox.attr('aria-expanded', 'false');
        }
        $placeholder.toggleClass('hide');
    }

    function labelOnClick(e) {
        var $checkbox = $(this).closest('.js-collection-item').find('.js-collection-checkbox').first();
        toggleCheckbox($checkbox);

        var $checkBoxContainer = $(this).closest('.js-collection-child-list-item');
        updateFacetDescendantCheckboxes($checkbox, $checkBoxContainer, '.js-collection-checkbox');
        doCollectionFacetQuery();
    }
    function toggleCheckbox($checkbox) {
        if ($checkbox.is(':checked')) {
            $checkbox.prop('checked', false);
        } else {
            $checkbox.prop('checked', true);
        }
    }

    function checkboxOnClick() {
        var $checkBoxContainer = $(this).closest('.js-collection-child-list-item');
        updateFacetDescendantCheckboxes($(this), $checkBoxContainer, '.js-collection-checkbox');
        doCollectionFacetQuery();
    }

    function doCollectionFacetQuery() {
        var updatedUrl = getUpdateQueryStringUrl();
        SCM.SearchResults.doSolrSearch({ queryString: updatedUrl });
    }

    function getUpdateQueryStringUrl() {
        var currentUrl = getCurrentDecodedUrl();

        var siteIdFacetValues = getFacetValues('siteid');
        var updatedUrl = getUpdatedQueryString(currentUrl, siteIdFacetValues, 'collection');

        var bookIdFacetValues = getFacetValues('bookid');
        updatedUrl = getUpdatedQueryString(updatedUrl, bookIdFacetValues, 'subcollection');

        return updatedUrl;
    }

    function getCurrentDecodedUrl() {
        var currentDataUrl = $('#CollectionCurrentDataUrl').val();
        return decodeURIComponent(currentDataUrl);
    }

    function getFacetValues(identifier) {
        var facetValues = [];
        $('.js-collection-facet').find('.js-collection-checkbox:checked').each(function () {
            var $parent = $(this).parents('.js-parent');
            if ($parent.length) {
                var $parentCheckbox = $parent.find('.js-collection-checkbox:first:checked');
                if ($parentCheckbox.length) {
                    var dataId = $parentCheckbox.data(identifier);
                    if (dataId > 0 && facetValues.indexOf(dataId) === -1) {
                        facetValues.push(dataId);
                    }
                }
                else {
                    var dataId = $(this).data(identifier);
                    if (dataId > 0) {
                        facetValues.push(dataId);
                    }
                }
            }
        });

        return facetValues;
    }

    function getUpdatedQueryString(currentDataUrl, facetValues, paramaterName) {
        var paramaterNameWithEqual = paramaterName + '=';
        var paramaterNameWithAndEqual = '&' + paramaterName + '=';

        var currentValue = SCM.JSUtility.getSearchParamByName(paramaterName);
        var facetQsPresent = (currentValue === null || currentValue === '') ? false : true;

        if (!facetQsPresent && facetValues.length > 0) {
            currentDataUrl += paramaterNameWithAndEqual + facetValues.join(',');
        } else if (facetQsPresent) {

            if (facetValues.length > 0) {
                var newQuery = paramaterNameWithEqual + facetValues.join(',');
                currentDataUrl = currentDataUrl.replace(paramaterNameWithEqual + currentValue, newQuery);
            } else {
                var existingQuery = paramaterNameWithEqual + currentValue;
                var startIndex = currentDataUrl.indexOf(existingQuery);
                var endIndex = startIndex + existingQuery.length;

                if (currentDataUrl.charAt(startIndex - 1) === '&') {
                    existingQuery = '&' + existingQuery;
                } else if (currentDataUrl.charAt(endIndex + 1) === '&') {
                    existingQuery = existingQuery + '&';
                }

                currentDataUrl = currentDataUrl.replace(existingQuery, '');
            }
        }
        return currentDataUrl;
    }

    function updateFacetDescendantCheckboxes($checkbox, $checkBoxContainer, checkboxClass) {
        var isChecked = $checkbox.is(':checked');
        updateDescendantCheckboxes($checkBoxContainer, checkboxClass, isChecked);
        updateAncestorCheckboxes($checkbox, checkboxClass);
    }

    function updateDescendantCheckboxes($container, checkboxClass, isChecked) {
        $container.find(checkboxClass).prop('checked', isChecked);
    }
    function updateAncestorCheckboxes($checkbox, checkboxClass) {
        var $parentCheckbox = $checkbox.closest('li').parent().closest('li').find(checkboxClass + ':first');
        while ($parentCheckbox.length) {
            var $parentLi = $parentCheckbox.closest('li');
            var $childCheckboxes = $parentLi.find('ul li ' + checkboxClass);
            var $checkedChildren = $parentLi.find('ul li ' + checkboxClass + ':checked');

            if ($childCheckboxes.length > 0) {
                var allChecked = $childCheckboxes.length === $checkedChildren.length;
                // Update the parent checkbox based on the state of its children
                $parentCheckbox.prop('checked', allChecked);
            }

            // Move to the next ancestor
            $parentCheckbox = $parentLi.parent().closest('li').find(checkboxClass + ':first');
        }
    }
    function toggleCollectionParent() {
        $checkedItems = $('.js-collection-checkbox:checked');
        if ($checkedItems.length > 0) {
            $checkedItems.parents('.js-collection-child-list-item').each(function () {
                expandChildList($(this));
            });
        }
    }

    function expandChildList($childListItem) {
        var $arrowLink = $childListItem.find('.js-collection-arrow').first();
        var $icon = $arrowLink.children('.js-collection-arrow-icon');
        if ($arrowLink && $arrowLink.length && $icon.hasClass('icon-general-arrow-filled-right')) {
            $arrowLink.parent('.js-collection-item').children('.js-collection-headings-placeholder').toggleClass('hide');
            $icon.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
        }
    }
})(jQuery);